var React = require('react');

function ArrowBlue (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 6.66667L6.85714 5.45455L1.24675 0L0 1.21212L5.61039 6.66667L0 12.1212L1.24675 13.3333L6.85714 7.87879L8 6.66667Z","fill":"#2DC5FA"}));
}

ArrowBlue.defaultProps = {"width":"8","height":"14","viewBox":"0 0 8 14","fill":"none"};

module.exports = ArrowBlue;

ArrowBlue.default = ArrowBlue;
